export default "__VITE_ASSET__DhESId3q__";